
export default function (Component) {
  Component.options.__source = "src/components/view-bus/index.vue"
}
